import { FilePdf, FileDoc, FileImage, FileText } from "@phosphor-icons/react";

export function fmtBytes(bytes) {
  if (bytes == null) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let i = -1;
  do { bytes /= 1024; i++; } while (bytes >= 1024 && i < units.length - 1);
  return `${bytes.toFixed(bytes < 10 ? 1 : 0)} ${units[i]}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch { return iso; }
}

const CURRENCY_SYMBOLS = { USD: "$", CAD: "CA$", GBP: "£", EUR: "€", AUD: "A$", NGN: "₦", GHS: "GH₵", KES: "KSh", ZAR: "R", AED: "AED " };
const WHOLE_CURRENCIES = new Set(["NGN", "GHS", "KES", "ZAR", "AED"]);

export const FLAGS = { US: "🇺🇸", CA: "🇨🇦", GH: "🇬🇭", KE: "🇰🇪", NG: "🇳🇬", ZA: "🇿🇦", GB: "🇬🇧", AU: "🇦🇺", AE: "🇦🇪", EU: "🇪🇺" };

export function fmtMoney(minor, currency = "USD") {
  const major = (minor || 0) / 100;
  const sym = CURRENCY_SYMBOLS[currency] || "$";
  if (WHOLE_CURRENCIES.has(currency)) return `${sym}${Math.round(major).toLocaleString()}`;
  return `${sym}${major.toFixed(2)}`;
}

export function fileMeta(ext) {
  switch (ext) {
    case "pdf": return { Icon: FilePdf, color: "text-red-500", bg: "bg-red-50" };
    case "doc":
    case "docx": return { Icon: FileDoc, color: "text-blue-600", bg: "bg-blue-50" };
    case "jpg":
    case "jpeg":
    case "png": return { Icon: FileImage, color: "text-emerald-600", bg: "bg-emerald-50" };
    default: return { Icon: FileText, color: "text-slate-500", bg: "bg-slate-100" };
  }
}

export const CATEGORY_COLORS = {
  Identity: "bg-blue-100 text-blue-700",
  Education: "bg-purple-100 text-purple-700",
  Family: "bg-pink-100 text-pink-700",
  Financial: "bg-emerald-100 text-emerald-700",
  Property: "bg-amber-100 text-amber-700",
  Business: "bg-indigo-100 text-indigo-700",
  Legal: "bg-red-100 text-red-700",
  Insurance: "bg-teal-100 text-teal-700",
  Other: "bg-slate-100 text-slate-700",
};

export const ACTION_LABELS = {
  "account.register": "Created account",
  "account.login": "Signed in",
  "account.login_2fa": "Signed in with 2FA",
  "account.login_google": "Signed in with Google",
  "account.email_verified": "Verified email",
  "document.upload": "Uploaded a document",
  "document.uploaded": "Uploaded",
  "document.update": "Updated a document",
  "document.delete": "Deleted a document",
  "document.download": "Downloaded a document",
  "document.downloaded": "Downloaded",
  "document.scanned": "Scanned with DuruScan",
  "document.classified": "Classified by DuruScan",
  "document.shared": "Shared",
  "document.access_revoked": "Revoked access",
  "document.signature_requested": "Requested signatures",
  "document.signed": "Signed",
  "document.verified": "Created a verification record",
  "share.create": "Created a share link",
  "share.revoke": "Revoked a share link",
  "signature.requested": "Requested signatures",
  "signature.completed": "Signing completed",
  "signature.voided": "Voided a signature request",
  "signature.reminded": "Sent a signing reminder",
  "session.revoked": "Revoked a session",
  "2fa.enabled": "Enabled two-factor auth",
  "2fa.disabled": "Disabled two-factor auth",
  "verification.create": "Created a DuruVerify record",
  "verification.scan": "A DuruVerify link was checked",
  "verification.revoke": "Revoked a DuruVerify record",
  "issuer.application": "Institution applied for DuruVerify",
};
